module.exports = __webpack_public_path__ + "static/semaforo.e3af1f98.gif";


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/images/semaforo.gif
// module id = 530
// module chunks = 13